import script from "./RedeemFormForCertification.vue?vue&type=script&setup=true&lang=js"
export * from "./RedeemFormForCertification.vue?vue&type=script&setup=true&lang=js"

import "./RedeemFormForCertification.vue?vue&type=style&index=0&id=741c94a0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-741c94a0"]])

export default __exports__